import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';

@Entity('t_migration_log')
export class MigrationLogEntity {
    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'table_name'
    })
    tableName: string;

    @Column('date', {
        nullable: false,
        name: 'migration_date',
        //default: () => 'CURRENT_DATE'
    })
    migrationDate: string;

    @Column('tinyint', {
        nullable: false,
        name: 'hour'
    })
    hour: number;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'unit'
    })
    unit: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'line_id'
    })
    lineId: string;

    @Column('tinyint', {
        nullable: false,
        default: () => 0,
        name: 'status'
    })
    status: number;

    @Column('text', {
        nullable: true,
        name: 'fail_reason'
    })
    failReason: string;

    @CreateDateColumn({ name: 'created_at' })
    createdAt: Date;

    @UpdateDateColumn({ name: 'updated_at' })
    updatedAt: Date;
}